export default function () {
    return {
        api: 'api.php',
        imageUploadUrl: 'api-import.php',
    }
}
